




$(document).on('click', '.watch-video', function () {
    var title = $(this).text();
    var video_url = $(this).data('url');
    $('.video-popup--title').text(title);
    $('.video-popup').addClass('active');
    var video = `<iframe src="${video_url}?enablejsapi=1&autoplay=1" class="video-div" allow="autoplay; encrypted-media" allowfullscreen title=""></iframe>`;
    $('.video-popup--body').append(video);
});

$(document).on('click', '.icon-close', function(){
    $('.video-popup').removeClass('active');
    $('.video-popup--body').empty();
});

$(document).on('change', '#quantity', function(){
    var qty = $(this).val();
    $('input[name="properties[_picking_bundle_qty0]"]').val(qty);
    $('.bundle-qty').each(function(){
        $(this).val($(this).data('origin-qty') * qty);
    });
});

$(document).ready(function () {
  var $desc = $('.container--reading-width');
  var $content = $desc.find('.rte');
  var maxHeight = 300;
  if ($content.height() > maxHeight) {
    $content.css({
      'height': maxHeight,
      'overflow': 'hidden'
    });
    var $button = $('<div class="read-more-btn">Read More</div>');
    $desc.append($button);
    $button.on('click', function () {
      var expanded = $desc.attr('aria-expanded') === 'true';
      $desc.attr('aria-expanded', !expanded);
      if (expanded) {
        $content.animate({ height: maxHeight }, 300);
        $button.text('Read More');
      } else {
        $content.animate({ height: $content.get(0).scrollHeight }, 300);
        $button.text('Read Less');
      }
    });
  }
});
